import { defineComponent as _defineComponent } from 'vue'
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { values } from '@/utils/enum';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import { onMounted, ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TimeAxisSpanButton',
  props: {
    position: { default: 'is-right' },
    value: { default: FilterTimeAxisSpanEnum.Day }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ((e: 'input', value: FilterTimeAxisSpanEnum) => void), expose: any, slots: any, attrs: any }) {





const dropdownRef = ref<any>(null);
const timeAxisSpans = ref<FilterTimeAxisSpanEnum[]>([]);

onMounted(() => {
  initialize();
});

function toggle() {
  dropdownRef.value?.toggle();
}

function initialize() {
  timeAxisSpans.value = values(FilterTimeAxisSpanEnum).filter(
    (x) =>
      x !== FilterTimeAxisSpanEnum.None && x !== FilterTimeAxisSpanEnum.Hour,
  );
}

expose({ toggle });

return { __sfc: true,emit, dropdownRef, timeAxisSpans, toggle, initialize, translateFilterTimeAxisSpanEnum }
}

})